<template>
  <div>
    <CreateLocationDialog ref="createLocationDialog" />
    <EditLocationDialog ref="editLocationDialog" />
    <v-card-actions class="card-bg-1 py- layout wrap">
      <v-btn @click="CreateLocationDialog()" color="success">
        <v-icon class="mr-2">add</v-icon>
        <div class="text-capitalize">
          Create monitoring location..
        </div>
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-layout class="align-baseline py-2">
      <v-item-group mandatory v-model="filterToggle" active-class="white--text">
        <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter clickable" @click="toggle">All</v-chip>
        </v-item>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter clickable" @click="toggle">
            <div style="float: left;" class="pr-2" :class="{ 'error--text font-weight-bold': noDataTypeItems.length > 0 }">
              {{ noDataTypeItems.length }}</div>
            Empty
          </v-chip>
        </v-item>
      </v-item-group>
      <v-spacer />
      <v-text-field class="rounded emphasize-clear" prepend-inner-icon="search" v-model="search" clearable solo placeholder="Search monitoring locations" hide-details />
    </v-layout>
    <v-divider />
    <v-data-table :headers="headers" :pagination.sync="pagination" :items="filteredItems" :search="search" class="elevation-1">
      <template v-slot:items="{ item }">
        <td>
          <div>
            <v-icon class="mr-2" small>open_in_new</v-icon>
            <router-link target="_blank" :to="{ name: 'monitoringfeature', params: { monitoringFeatureId: item.id }}">
              <strong>{{ item.primaryName }}</strong>
            </router-link>
          </div>
        </td>
        <td>
          <v-chip v-for="(dataSource, index) in item.dataTypes" :key="`dataSource-${index}`" label small>
            {{ dataSource.station.LocationIdentifier }} [{{ dataSource.type }}]
          </v-chip>
          <v-chip v-if="item.dataTypes.length == 0" outline color="error" small label>
            No data types
          </v-chip>
        </td>
        <td class="text-xs-center">
          <v-tooltip :open-delay="500" left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="editItem(item)">
                <v-icon color="warning">edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Button.Edit") }}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const navigation = createNamespacedHelpers('navigation')

  import CreateLocationDialog from './CreateLocationDialog'
  import EditLocationDialog from './EditLocationDialog'

  export default {
    components: {
      CreateLocationDialog,
      EditLocationDialog,
    },
    data: () => ({
      search: '',
      filterToggle: 0,
      headers: [{
        text: 'Location Name',
        value: 'primaryName',
      },
      {
        text: 'Data Sources',
        value: 'dataSourceLength',
      },
      {
        text: 'Actions',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
      ],
      pagination: {
        rowsPerPage: 10,
        page: 1,
      },
    }),
    computed: {
      ...monitoringFeatures.mapGetters([
        'monitoringFeatures',
        'getDisplayName',
      ]),
      ...navigation.mapGetters(['searchableLocationItems']),
      items() {
        return this.searchableLocationItems.map(mf => {
          return {
            ...mf,
            name: this.getDisplayName(mf),
            dataSourceLength: mf.dataTypes.length,
          }
        })
      },
      noDataTypeItems() {
        return this.items.filter(i => i.dataTypes.length == 0)
      },
      filteredItems() {
        return this.filterToggle == 0 ? this.items : this.noDataTypeItems
      },
    },
    methods: {
      showEmpty() {
        this.filterToggle = 1
      },
      editItem(item) {
        this.$refs.editLocationDialog.show(item)
      },
      CreateLocationDialog() {
        this.$refs.createLocationDialog.show()
      },
    },
  }
</script>